import * as maplibregl from 'maplibre-gl';
import { Protocol } from 'pmtiles';

export { countryAt, DALE_MAP_ATTRIBUTION, DALE_MAP_COLORS, DALE_MAP_REGIONS, daleFlavor, daleMapStyle, type MapCountry } from './style';
export { createPinElement, PIN_ANCHOR, setPinSelected, type PinOptions } from './pins';
export { maplibregl };

let registered = false;

/** Teaches MapLibre the pmtiles:// scheme once per page. */
export function registerDaleMaps(): typeof maplibregl {
  if (!registered) {
    maplibregl.addProtocol('pmtiles', new Protocol().tile);
    registered = true;
  }
  return maplibregl;
}
